import script from "./schema-form-item.vue?vue&type=script&setup=true&lang=tsx&name=SchemaFormItem"
export * from "./schema-form-item.vue?vue&type=script&setup=true&lang=tsx&name=SchemaFormItem"

const __exports__ = script;

export default __exports__